// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/company_settings/most_used_events_and_attributes_by_apps_and_app_groups" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companySettingsMostUsedEventsAndAttributesByAppsAndAppGroups } from "./constants";
import type {
  CompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsParams,
  CompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsResult,
} from "./types";

export const getDataTableCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroups =
  reactQueryTableFetcherAdapter(
    companySettingsMostUsedEventsAndAttributesByAppsAndAppGroups,
    (
      signal: AbortSignal,
      {
        appGroupId,
        query,
        groupby,
        limit = 20,
        start = 0,
        sortdir,
        sortby,
      }: CompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsParams
    ): Promise<CompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsResult> => {
      return fetch(
        "/company_settings/most_used_events_and_attributes_by_apps_and_app_groups",
        "GET",
        {
          groupby,
          limit,
          sortby,
          sortdir,
          start,
          app_group_id: appGroupId,
          query: serializeQueryObjects(query),
        },
        { signal }
      );
    }
  );
